import { useLang } from "@/i18n";
import Reveal from "@/components/Reveal";

const PORTRAITS = {
  "jean-philippe": "/images/jean-philippe.jpg",
  michel: "/images/michel.jpg",
  "marie-helene": "/images/marie-helene.jpg",
  tetiana: "/images/tetiana.jpg",
};

export default function Team() {
  const { t } = useLang();
  const team = t.team;

  return (
    <section id="equipe" data-testid="team-section" className="scroll-mt-24 bg-paper py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-wood">{team.eyebrow}</p>
          <h2 className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight text-pine md:text-5xl">
            {team.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-pine/70 md:text-lg">{team.sub}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {team.members.map((member, i) => (
            <Reveal key={member.id} delay={i * 0.12}>
              <article data-testid={`team-member-${member.id}`} className="group">
                <div className="overflow-hidden rounded-2xl border border-pine/10">
                  <img
                    src={PORTRAITS[member.id]}
                    alt={`Portrait de ${member.name}`}
                    className="aspect-[3/4] w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
                  />
                </div>
                <div className="mt-5 flex items-baseline justify-between border-b border-pine/10 pb-4">
                  <h3 className="font-serif text-2xl tracking-tight text-pine">{member.name}</h3>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-wood">
                    {member.role}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
